import { createFileRoute, redirect } from '@tanstack/react-router'

import { defaultPromoSearch, promoSearchSchema } from '@/pages/promotion/search-schemas'

export const Route = createFileRoute('/promo')({
  component: () => null,
  validateSearch: (search) => promoSearchSchema.catch(defaultPromoSearch).parse(search),
  loaderDeps: ({ search }) => {
    return {
      search,
    }
  },
  loader: ({ deps: { search } }) => {
    throw redirect({
      to: '/promotion/free-bankroll',
      replace: true,
      search,
    })
  },
})
